import { useMemo } from "react";
import { useACLContext, type CheckOptions } from "../context";
import type { Action, Resource } from "@shield-acl/core";
import { stableKey } from "./internal";

/**
 * Verificação simples, memoizada. Reavalia quando user/roles/scope/opts mudam.
 *
 * @example
 * const canEdit = useCan("update", "posts", { record: post })
 * const canInB  = useCan("read", "posts", { scope: "app:B" })
 */
export function useCan(
  action: Action,
  resource?: Resource,
  opts?: CheckOptions,
): boolean {
  const { can, user, revision } = useACLContext();
  const key = stableKey(opts);
  return useMemo(
    () => can(action, resource, opts),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [can, action, resource, key, user, revision],
  );
}

export function useCannot(
  action: Action,
  resource?: Resource,
  opts?: CheckOptions,
): boolean {
  return !useCan(action, resource, opts);
}
